import { useEffect } from 'react'
import { Wifi as WifiIcon } from 'lucide-react'

type PostRestoreStep = 'select_wifi' | 'partial_setup' | 'enroll'

interface PostRestoreStepsProps {
  step: PostRestoreStep
  onNext: (nextStep: PostRestoreStep | 'verify_enrollment') => void
}

// Preload images as soon as this component mounts (during WiFi step)
// so they're cached by the time the user reaches partial_setup and enroll
const IMAGE_URLS = ['/partial_setup.png', '/enroll.png']

export default function PostRestoreSteps({ step, onNext }: PostRestoreStepsProps) {
  useEffect(() => {
    IMAGE_URLS.forEach((src) => {
      const img = new Image()
      img.src = src
    })
  }, [])

  if (step === 'select_wifi') {
    return (
      <div className="text-center space-y-6">
        <p className="text-gray-600">
          Your device has rebooted. On your iPhone, connect to your <strong>WiFi network</strong>.
        </p>
        <div className="flex justify-center py-4">
          <WifiIcon size={120} className="text-brand" />
        </div>
        <button
          onClick={() => onNext('partial_setup')}
          className="w-full py-3 bg-brand text-white rounded-xl hover:bg-brand-hover transition-colors font-medium"
        >
          Next
        </button>
      </div>
    )
  }

  if (step === 'partial_setup') {
    return (
      <div className="text-center space-y-6">
        <p className="text-gray-600">
          On your iPhone, tap <strong>&quot;Continue with Partial Setup&quot;</strong> when prompted.
        </p>
        <div className="flex justify-center">
          <img
            src="/partial_setup.png"
            alt="Continue with Partial Setup"
            className="rounded-2xl shadow-lg"
            style={{ maxWidth: '280px', height: 'auto' }}
            width={280}
            height={200}
            loading="eager"
          />
        </div>
        <button
          onClick={() => onNext('enroll')}
          className="w-full py-3 bg-brand text-white rounded-xl hover:bg-brand-hover transition-colors font-medium"
        >
          Next
        </button>
      </div>
    )
  }

  // enroll
  return (
    <div className="text-center space-y-6">
      <p className="text-gray-600">
        On your iPhone, tap the <strong>&quot;Enroll&quot;</strong> button to complete enrollment.
      </p>
      <div className="flex justify-center">
        <img
          src="/enroll.png"
          alt="Tap Enroll"
          className="rounded-2xl shadow-lg"
          style={{ maxWidth: '280px', height: 'auto' }}
          width={280}
          height={200}
          loading="eager"
        />
      </div>
      <button
        onClick={() => onNext('verify_enrollment')}
        className="w-full py-3 bg-brand text-white rounded-xl hover:bg-brand-hover transition-colors font-medium"
      >
        Next
      </button>
    </div>
  )
}
